<template>
  <v-container>
    <v-layout>
      <v-flex>
        <v-text-field v-model="searchInfo.keyword" label="搜尋"
                      :color="Theme.GREEN" placeholder="查詢門市名稱"></v-text-field>
      </v-flex>
      <v-flex>
        <v-btn class="mr-2" :color="Theme.GREEN" dark @click.prevent="searchEvent">搜尋</v-btn>
        <v-btn :color="Theme.YELLOW" dark @click.prevent="reset">重置</v-btn>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <table-view :items="items"
                    :columnKeys="columnKeys"
                    :pagination="pagination"
                    :loading="loading"
                    @changePage="changePage"
                    @cellEvent="cellEvent"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import TableView from "@/components/TableView";
import {  mapActions } from "vuex";
import common from "@/mixins/common";
export default {
  name: "contract",
  components: {
    TableView,
  },
  mixins:[common],
  data() {
    return {
      itemDetail: {},
      dialogFormVisible: false,
      searchInfo: {
        keyword: ''
      },
      mode: 'insert',
      items: [],
      loading: false,
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0,
      },
    }
  },
  created() {
    this.loadData();
  },
  mounted() {

  },
  computed: {
    columnKeys() {
      return [
        { value: 'download', text: '下載', sort: false , isEvent: true, color: this.Theme.GREEN, sortable: false},
        { value: 'contractId', text: '合約編號', sort: false },
        { value: 'name', text: '姓名', sort: false },
        { value: 'email', text: 'Email', sort: false },
        { value: 'cellphone', text: '電話', sort: false },
        { value: 'birthday', text: '生日', sort: false },
        { value: 'gender', text: '性別', sort: false },
        { value: 'leftDiopter', text: '左眼度數', sort: false },
        { value: 'rightDiopter', text: '右眼度數', sort: false },
        { value: 'createdDate', text: '簽約時間', sort: false },
      ];
    },
  },
  methods: {
    ...mapActions(['fetchContractList']),
    async loadData(){
      this.loading = true;
      const res = await this.fetchContractList({
        searchValue: this.searchInfo.keyword,
        pageIndex: this.pagination.page,
        limit: this.pagination.itemsPerPage,
      })
      this.loading = false;
      const result = res.data;
      console.log(JSON.stringify(result));
      if (result && result.code === 0){
        this.items = result.body.list;
        this.pagination.totalItems = result.body.header.totalCount;
      }
    },
    changePage(value){
      console.log(`changePage = ${JSON.stringify(value)}`);
      this.pagination.page = value.page;
      this.pagination.itemsPerPage = value.itemsPerPage;
      this.loadData();
    },
    cellEvent(cell) {
      console.log(`cellEvent ${cell.key} ${JSON.stringify(cell.item)}`);
      if (cell.key === 'download'){
        this.downloadContract(cell.item);
      }
    },
    downloadContract(contract){
      console.log(`downloadContract = ${JSON.stringify(contract)}`);
      if (contract.signatureURL && contract.signatureURL !== ''){
        const url = `https://sign.innovision.com.tw/?contractId=${contract.contractId}`;
        window.open(url, '_blank');
      } else {
        alert('找不到合約檔案！')
      }
    },
    searchEvent(){
      this.loadData();
    },
    reset(){
      this.searchInfo.keyword = '';
      this.pagination = {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0,
      };
      this.loadData();
    }
  }
}
</script>

<style scoped>

</style>
